export default {
    __locale: 'ja',
    a_momentary_about_1_second_seizure_such_as_stretching_the_limbs: "手足を「グっ」とのばす、頭を前にたおす(うなずく)などの一瞬(1秒ぐらい)の発作",
    a_seizure_in_which_the_whole_body_suddenly_loses_power: "突然全身の力が抜ける発作(あやつり人形の糸を切った様に)",
    about_service: "サービスについて",
    absence_seizures: "欠神発作",
    access_confirmation: "アクセス確認",
    accessable: "アクセスできます",
    add_new: "新規追加",
    added_shortcut_name_for_seizure_type: "発作種類のショートカット名を追加<br>・編集することができます。",
    after_a_while_you_will_be_asked_for_permission_to_use_the_opt_so_please_allow_it: "しばらくすると、ワンタイムパスワード利用の許可を求められるので、許可してください",
    age: "年齢",
    age_ages: "0歳 | 1歳 | {count}歳",
    age_colon: "年齢：",
    agree_to_terms_of_service: "<a href='/legal/termsofuse' target='_blank'>利用規約</a>に同意する",
    all__2c: "全て",
    all_types_of_seizures: "発作種類 全て",
    all__3c: "すべて選択",
    allergy: "アレルギー",
    an_error_occurred_while_retrieving_token: "An error occurred while retrieving the token.",
    animal: "動物",
    api_has_occurred_with_status: "APIエラーが発生しました(コード: {status} )",
    application_not_entered: "アプリ未入力",
    attachment_up_to_10_mb: "添付ファイル(上限10MB)",
    atonic_seizure: "脱力発作",
    author: "作成者",
    average_number_of_seizures_patient: "発作平均回数(1日平均)※直近一週間",
    back: "戻る",
    back_to_index: "一覧に戻る",
    basic_information: "基本情報",
    basic_information_seizure_information: "基礎情報・発作情報",
    before_using_the_service: "サービスをご利用の前に",
    body_10000_characters: "本文(10000文字)",
    brackets_1_month_30_days: "（1カ月間：30日）",
    brackets_1_year_360_days: "（1年間：360日）",
    browsing_is_not_allowed: "閲覧が許可されていません",
    btn_update: "更新",
    by_day: "日別",
    by_month: "月別",
    by_week: "週別",
    cancel: "キャンセル",
    cannot_access: "アクセスできません",
    cannot_access_to_domain: 'api-dr.kod-hc.jpのドメインにアクセスできません',
    cannot_be_displayed_because_it_is_a_combination_lock: "配合錠のため表示不可",
    cannot_specify_the_entered_date: "入力した日付を指定できません",
    change_password: "パスワード変更",
    check_otp_by_app: "患者さまのnanacaraアプリで発行した、ワンタイムパスワードを確認してください。",
    clonus_seizures: "間代発作",
    color: "カラー",
    comma: "、",
    configuration: "設定",
    confirm: "認証",
    confirm_new_password: "新しいパスワードを確認",
    confirm_the_official_password: "正式なパスワードを確認",
    contact: "お問い合わせ",
    contact_content_is_required: "お問い合わせ内容は必須です",
    contact_input: "お問い合わせ入力",
    contact_input_confirmation: "お問い合わせ入力確認",
    contact_transmission_completed: "お問い合わせ送信完了",
    content_confirmation: "内容確認",
    contents_of_contact: "お問い合わせ内容",
    copyright_2020_knock_on_the_door: "Copyright &copy; 2020 KNOCK ON THE DOOR Inc.",
    data_viewing_is_valid_for_2_hours: "・データ閲覧は、nanacaraアプリ側がワンタイムパス発行後、2時間有効です。",
    date_and_time_of_transmission: "送信日時",
    date_colon: "日付: ",
    day: "日",
    decrease: "減少",
    delete: "削除",
    delivery: "配信",
    deterioration: "悪化",
    determining_seizure_classification_is_not_a_diagnosis: "発作分類の決定は、診断を行うものではありません。不明な場合は、「分からない」を選択してください。",
    disease_name: "病名",
    disease_name_operation: "病名 / 手術内容",
    display: "表示",
    display_content: "【表示内容】",
    display_method_colon: "表示方法：",
    display_period: "表示期間",
    display_period_colon: "表示期間: ",
    display_period_setting: "表示期間設定",
    display_period_setting_3_months: "表示期間設定 3ヶ月",
    display_period_setting_6_months: "表示期間設定 6ヶ月",
    display_period_setting_day: "表示期間設定 日間",
    display_period_setting_month: "表示期間設定 月間",
    display_period_setting_week: "表示期間設定 週間",
    display_period_setting_year: "表示期間設定 年間",
    display_period_setting_3_year: "表示期間設定 3年",
    display_period_setting_5_year: "表示期間設定 5年",
    display_period_setting_all_year: "表示期間設定 通年",
    do_you_want_to_delete_the_notification: "お知らせを削除しますか？",
    do_you_want_to_export_to_pdf: "PDFに書き出ししますか？",
    do_you_want_to_log_out: "ログアウトしますか？",
    do_you_want_to_save_the_draft: "下書きを保存しますか?",
    doctor_doctor: "{doctor}先生",
    doctor_in_charge: "担当医",
    doctor_in_charge_colon: "担当ドクター: ",
    doctor_name: "お名前",
    doctor_note_500_characters: "医師用メモ(500文字以内)",
    dosing_bar: "薬剤投薬バー",
    dosing_during_seizures: "発作時投薬",
    dosing_during_the_evaluation_period: "評価期間中の投薬",
    dosing_during_the_observation_period: "観察期間中の投薬",
    dosing_period: "服薬期間",
    dosing_start_date: "服薬開始日",
    dot_accesssible: "・アクセス可能\n",
    dot_age: "・年齢",
    dot_average_number_of_seizures_info: "・1日あたりの平均発作回数(直近1週間)",
    dot_average_number_of_seizures_patient: "・発作平均回数(1日平均)※直近一週間",
    dot_gender: "・性別",
    dot_medication_history: "・服薬履歴",
    dot_name: "・名前",
    dot_name__3c: "・&nbsp;お名前",
    dot_symptom_name: "・症状名",
    dot_tab_medication_history: "・ 服薬履歴",
    dot_tab_seizure_type_type: "・&nbsp;発作種類{type}",
    dot_tab_symptom_name: "・ 病名",
    dot_types_of_seizures: "・発作種類(最大6種類、その他)",
    dot_unaccessible: "・アクセス不可\n",
    drafting: "下書き中",
    email_address: "メールアドレス",
    email_address_confirmation: "メールアドレス確認",
    email_address_is_incorrect: "メールアドレスが正しくありません。",
    email_address_is_required: "メールアドレスは必須です",
    email_addresses_do_not_match: "メールアドレスが一致しません。",
    end_date: "通院終了日",
    epileptic_spasm_series: "てんかん性スパズム(シリーズ)",
    epileptic_spasm_single: "てんかん性スパズム(単発)",
    error_check: {
        accessible: {
            block_1: "",
            block_2: "こちら",
            block_3: "よりお問い合わせをお願いします",
        },
        unaccessible: {
            lan_wifi: {
                block_1: "\t[有線LAN、Wifiをお使いの場合]\n\t\tお使いのネットワークでapi-dr.kod-hc.jpへのアクセスが制限されている可能性があります\n\t\tお手数ですが、ネットワーク管理者へapi-dr.kod-hc.jpへのアクセスが可能かご確認をお願いします。\n\t\tご不明点がある場合は",
                block_2: "こちら",
                block_3: "よりお問い合わせをお願いします"
            },
            mobile_network: {
                block_1: "\t[モバイル回線をお使いの場合]\n\t\tセキュリティソフトなどをインストールしている場合は、アクセス可能なドメインが制限されていないかご確認をお願いします。\n\t\tご不明点がある場合は",
                block_2: "こちら",
                block_3: "よりお問い合わせをお願いします"
            }
        }
    },
    evaluation_period: "評価期間",
    evaluation_unit: "評価単位",
    example_name: "例）山田 太郎",
    example_email: "例）abc.test.co.jp",
    facility_name: "施設名",
    female: "女",
    files_larger_than_10_mb_cannot_be_attached: "10MB以上のファイルは添付できません。",
    focus_on_patients_who_can_view: "閲覧可能患者に絞る",
    focus_origin_tonic_clonic_seizures: "焦点起始強直間代発作",
    focus_partial_seizures_conscious: "焦点(部分)発作(意識あり)",
    focus_partial_seizures_unconscious: "焦点(部分)発作(意識なし)",
    focused_seizures_that_are_unresponsive_unconscious_when_called: "焦点発作のうち、呼んでも反応がない(意識がない)発作",
    food: "食物",
    for_investigation_purpose_please_do_not_edit_and_send_this_information: "[調査用情報]※こちらは編集せずに送信してください\n",
    forgot_password: "パスワードを忘れた方",
    gender: "性別",
    gender_colon: "性別：",
    help_otp: {
        confirm_and_enter_otp_by_app: "患者・ご家族からワンタイムパスワードを聞いて入力してください。",
        how_to_use_app: "患者・ご家族のアプリの操作方法",
        procedure_for_issuing_otp: "ワンタイムパスワードの発行手順(患者・ご家族のアプリ)",
        step_1: "画面右下の「診療」をクリックし、「ワンタイムパスワード発行」ボタンをタップしてください",
        step_2: "ワンタイムパスワード発行ボタンをタップしてください",
        step_3: "発行したワンタイムパスワードをDr.に伝えてください",
        step_4: "しばらくすると、ワンタイムパスワード利用の許可を求められるので、許可してください",
    },
    home_care_notebook: '在宅療養手帳',
    hospital_visiting_history: '通院歴',
    hour: "{hour}時",
    how_to_issue_a_otp: "ワンタイムパスワードの発行方法",
    i_am_uploading_an_image: "画像をアップロードしています",
    i_do_not_find_this_notification: "このお知らせを表示できません。",
    i_do_not_understand: "分からない",
    i_saved_the_draft: "下書きを保存しました",
    id_email_address: "ID / メールアドレス",
    inquiry_details_is_required: "お問い合わせ内容は必須です",
    if_in_use_is_displayed_cooperation_is_complete_the_medical_examination_has_started: "「利用中」と表示されれば、連携完了。診察開始です！",
    if_no_text_please_upload_the_attached_file: "「本文なし」の場合は、添付ファイルをアップロードしてください。",
    if_the_app_user_stops_using_the_otp: "・アプリユーザがワンタイムパスの利用を停止した場合は、患者情報の閲覧も停止します。",
    if_the_screen_does_not_switch_press_reload: "画面が切り替わらない場合は、再読み込みを押してください。",
    if_the_site_does_not_open: "・ワンタイムパスワードを入力してもサイトが開かない場合は、ワンタイムパスワードを再度発行してください。",
    if_you_check_no_text_you_cannot_edit_the_text: "※「本文なし」をチェックすると本文を編集できません。(タイトルとファイルのみで送信します)",
    if_you_do_not_receive_a_call_back_from_us_within_3_business_days: "3営業日以内に弊社より折り返しがない場合、お問い合わせが正しく完了していない場合がございます。<br />お手数ではございますが、再度問い合わせをお願いいたします。",
    title_tooltip_data_patient_chart: "週間、月間、3ヶ月、6ヶ月、年間の日付を入力する場合は、終了日のみ入力可能となります。日付をカレンダーから選択する場合も、終了日の選択のみとなります。終了日を入力または選択すると、開始日が自動で入力されます。",
    if_you_enter_the_password_presented_to_the_patient_nanacara_app: "・診察時に、患者のnanacaraアプリに提示されたパスワードをnanacara for Doctorのワンタイムパス入力ページで入力すると、該当患者の発作データ、服薬履歴が閲覧できます。",
    if_you_want_to_attach_multiple_files_you_need_to_enter_the_text: "複数ファイルを添付する場合、本文を入力する必要があります。",
    if_you_want_to_return_to_the_previous_patient: "・次の患者のワンタイムパスワードを利用した後に、前の患者へ戻る場合は、再度ワンタイムパスワードを発行してください。",
    if_you_want_to_view_the_data_of_the_next_patient: "・診察終了後、次の患者のデータを閲覧する場合は、再度ワンタイムパス入力ページに戻り、患者から提示されたワンタイムパスを入力します。",
    image: {
        otp: {
            step: {
                1: "/common/img/onetime_step01.png",
                2: "/common/img/onetime_step02.png",
                3: "/common/img/onetime_step03.png",
                4: "/common/img/onetime_step04.png",
            }
        },
        info: {
            service: {
                1: "/common/img/img_service01.png",
                2: "/common/img/img_service02.png",
                3: "/common/img/img_service03.png",
                4: "/common/img/img_service04.png",
                5: "/common/img/img_service05.png",
                6: "/common/img/img_service06.png",
            },
            pic_service01: "/common/img/pic_service01.png",
        },
        patient: "/common/img/m_setting.png",
    },
    image_loading_error: "画像読み込みのエラー",
    in_the_case_of_no_text_only_one_file_can_be_attached: "※「本文なし」の場合、添付できるファイルは1ファイルとなります。",
    information_osaka_prefecture_special: "お知らせ（大阪府限定）",
    information_details: "お知らせ詳細",
    input_format: "[入力形式]パスワードは8文字以上大文字あり、半角英数字で入力してください。",
    input_of_seizure_type: "発作種類の入力",
    invalid: "無効",
    it_is_currently_being_processed: "ただいま処理中です。",
    keep_logged_in: "ログイン状態を保持する",
    lan_wifi: "・有線LAN、Wifi\n",
    last_seizure_date_and_time: "最終発作日時",
    last_viewed_date: "最終閲覧日",
    list_patients_who_have_been_viewed: "閲覧したことのある患者を一覧に表示する",
    loading: "Loading...",
    log_out: "ログアウト",
    login: "ログイン",
    maintenance_completed: "メンテナンス完了",
    maintenance_for_nanacara_for_doctor_has_ended: "nanacara for Doctorのメンテナンスは終了いたしました。",
    maintenance_time: "メンテナンス時間：",
    make_sure_js_is_enabled: "・JavaScriptが有効になっていることをご確認ください。",
    male: "男",
    medical_history: '病歴',
    medical_history_status: '状態',
    medical_institution: "医療機関名",
    medication_status: '服薬状況',
    medicine_list: "薬剤リスト",
    medicine_name: "薬剤名",
    medicines_being_taken: "服薬中薬剤",
    medications_being_taken: "服薬中の薬",
    metal: "金属",
    mobile_network: "・モバイル回線\n",
    month_colon: "月間: ",
    month_month: "{month}月",
    myoclonic_atonic_seizure: "ミオクロニー脱力発作",
    myoclonic_seizures: "ミオクロニー発作",
    name: "ニックネーム",
    nanacara_for_doctor_is_currently_undergoing_maintenance: "nanacara for Doctorは、現在メンテナンスを実施しております。",
    nanacara_for_doctor_is_for_patients: "nanacara for Doctorは、患者が<br>nanacaraアプリで記録した日々の発作状況、<br>服薬履歴を医師に共有し、診察時に医師が閲覧、<br>出力できるサービスです。​",
    next: "次",
    no: "NO",
    no_applicable_medicine: "該当する薬剤なし",
    no_body: "本文なし",
    no_data: "データなし",
    no_instance_id_token_available_request_permission_to_generate_one: "No instance ID token is available. Request permission to generate one",
    no_otp_entered: "ワンタイムパスワードが未入力です",
    not_connected_to_the_network: "ネットワークに接続されていません。",
    not_identify: "指定なし",
    note_electronic_health_record_url_etc: "メモ(電子カルテURLなど)",
    note_update_failed: "メモの更新に失敗しました。",
    notify_delivery_by_email: "配信をメールで通知",
    notice_list: "お知らせ一覧",
    notification: "お知らせ",
    notification_management: "お知らせ管理",
    number_of_seizures: "発作回数",
    number_of_seizures_average_per_day_last_week: "発作回数(1日平均)※直近1週間",
    number_of_shot_vaccin: "{count}回目",
    observation_period: "観察期間",
    of_the_seizure_images_taken_and_saved_by_the_patient: "nanacaraアプリで患者が撮影、保存した発作動画のうち、患者が診察時に医師に見せたい動画がnanacara for Doctorに共有されます。",
    ok: "OK",
    one_day: "日間",
    one_month: "月間",
    one_month_30_days: "1カ月(30日)",
    one_time_pass: "ワンタイムパス",
    one_week: "週間",
    one_year: "年間",
    three_year: "3年間",
    five_year: "5年間",
    all_periods: "全期間",
    one_year_360_days: "1年(360日)",
    ongoing_medication: "（服薬継続中）",
    only_pdf_files_and_image_files_can_be_attached: "PDFファイルと画像ファイル（JPEG、PNG、JPG）のみ添付できます。",
    operation: "手術",
    optional: "任意",
    order_cancellation_confirmation: "注文キャンセル確認",
    onset_seizure_operation_date: "発症日 / オペ日",
    other_medications_are_available: "※その他服薬中薬剤あり",
    other_seizures: "その他の発作",
    others: "その他",
    otp: "ワンタイムパスワード",
    otp_input: "ワンタイムパス入力",
    outpatient_treatment: "通院中",
    output_date_and_time: "出力日時",
    over_100: "100%以上",
    page_404_the_page_you_are_looking_for_cannot_be_found: "404 - お探しのページが見つかりません",
    pagination: {
        next: "次へ",
        previous: "前へ",
        the_first: "最初",
        the_last: "最後"
    },
    password: "パスワード",
    password_input: "パスワード入力",
    password_reset_is_complete: "パスワードの再設定が完了しました。",
    patient_info_button: {
        edit: "編集",
        register: "登録",
        save: "保存"
    },
    patient_information: "患者情報",
    patient_information_and_seizure_status_graph: "患者情報と発作状況グラフ",
    patient_information_medication_history_and_seizure_graph_can_be_output_as_pdf: "患者情報、服薬履歴、発作グラフをPDFで出力できます。発作グラフは設定した表示期間のグラフが出力されます。PDFには診察日が記載されます。",
    patient_list: "患者一覧",
    patient_list_off: "患者一覧OFF",
    patient_list_on: "患者一覧ON",
    pdf_export: "PDF書き出し",
    pdf_output: "PDF出力",
    period_setting_colon: "期間設定：",
    please_agree_to_the_terms_of_use: "利用規約に同意してください",
    please_enter_a_new_password: "新しいパスワードを入力してください",
    please_enter_a_new_password_to_confirm: "新しいパスワードを確認を入力してください",
    please_enter_a_title_title_is_required: "タイトルを入力してください。（タイトルは必須）",
    please_enter_the_confirmation_for_the_official_password: "正式なパスワードを確認を入力してください",
    please_enter_the_verification_code: "確認コードを入力してください",
    please_enter_the_text_using_10000_characters_or_less: "本文は10,000文字以下で入力してください。",
    please_enter_the_text_text_is_required: "本文を入力してください。（本文は必須）",
    please_enter_the_title_with_100_characters_or_less: "タイトルは100文字以下で入力してください。",
    please_enter_your_ID_email_address: "ID / メールアドレスを入力してください",
    please_enter_your_contact: "お問い合わせ内容を入力してください",
    please_enter_your_customer_information: "お客様情報を入力してください",
    please_enter_your_official_password: "正式なパスワードを入力してください",
    please_enter_your_password: "パスワードを入力してください",
    please_enter_your_registered_email_address: "登録済みのメールアドレスを入力してください",
    please_make_sure_that_cookies_are_enabled: "・Cookieが有効になっていることをご確認ください。",
    please_recheck_your_connect_network_and_try_again: "Please recheck your connect network and try again!",
    please_select_the_date: "日付を選択してください",
    please_tell_dr_the_otp_you_issued: "発行したワンタイムパスワードをDr.に伝えてください",
    please_wait: "しばらくお待ちください。",
    pollen: "花粉",
    prescription_drugs: "処方薬剤",
    prescription_start_date: "処方開始日",
    previous: "前",
    primary_disease: "基礎疾患",
    privacy_policy: "プライバシーポリシー",
    procedure_for_issuing_otp: "ワンタイムパスワードの発行手順",
    pw_reset_completed: "PW再設定完了",
    pw_reset_forgot: "PW再設定_忘れた方",
    pw_reset_temporary_password: "PW再設定_仮パスワード",
    recovery: "完治",
    reload: "再読み込み",
    reproduction: "再生",
    required: "必須",
    resetting_a_password: "パスワード再設定",
    return_to_login_screen: "ログイン画面へ戻る",
    save_draft: "下書きを保存",
    scroll: "スクロール",
    seizure_change_rate_graph: "発作変化率",
    seizure_classification: "発作分類",
    seizure_classification_supervision_osaka_city_general_medical_center: "※発作分類監修 大阪市総合医療センター",
    seizure_classification_vi: "発作分類",
    seizure_status_graph: "発作状況グラフ",
    seizure_status_graph_by_seizure_type: "発作グラフ",
    Seizure_graph_with_seizure_type: "発作種別の発作状況グラフ",
    seizure_type: "発作種類",
    seizure_type_please_tell_the_patient_to_set_the_type_of_seizure_diagnosed: "発作種類 ※患者さまに診断された発作種類を設定するようお伝えください。",
    seizure_type_setting_method: "発作種類設定方法",
    seizures_a: "発作A",
    seizures_b: "発作B",
    seizures_c: "発作C",
    seizures_classification_was_diagnosed_by_your_doctor: "発作分類は、かかりつけ医師から診断された<br>発作分類を選択してください。",
    seizures_count_graph: "発作回数グラフ",
    seizures_count_table: "発作回数表",
    seizures_d: "発作D",
    seizures_e: "発作E",
    seizures_f: "発作F",
    seizures_that_cause_the_whole_body_to_stretch_and_then_tingle: "全身が突っ張り、その後がくがく(ぴくぴく)させる発作",
    seizures_that_do_not_respond_to_the_call: "呼びかけに反応せず、ボーッとする発作",
    seizures_that_make_the_whole_body_or_part_of_the_body_snap_for_a_moment: "全身や体の一部が一瞬(びりっと電気が走ったように)「ぴくっ」とする発作",
    seizures_that_make_the_whole_body_scratchy: "全身をがくがく(ぴくぴく)させる発作",
    seizures_that_make_the_whole_body_stick_like_a_stick_for_a_while_a_few_seconds_to_10_seconds: "全身が棒のようにしばらく(数秒から10秒程度)つっぱる発作",
    seizures_that_transition_from_focused_seizures_to_tonic_clonic_seizures: "「焦点発作」から「強直間代発作」に移行する発作",
    seizures_that_weaken_the_whole_body_following_myoclonic_seizures: "ミオクロニー発作に続き全身の力が抜ける発作",
    seizures_type_colon: "発作種類：",
    seizures_type_and_others: "発作種類 その他",
    seizures_type_seizures_a: "発作種類 発作A",
    seizures_type_seizures_b: "発作種類 発作B",
    seizures_type_seizures_c: "発作種類 発作C",
    seizures_type_seizures_d: "発作種類 発作D",
    seizures_type_seizures_e: "発作種類 発作E",
    seizures_type_seizures_f: "発作種類 発作F",
    send: "送信する",
    send_email: "メールを送信",
    sent: "送信済み",
    service_function_description: "サービス機能説明",
    short_name: "略式名称",
    show_graph: "グラフを表示",
    significant_effect: "著効",
    since_the_number_of_seizures_during_the_observation_period_is_0: "観察期間の発作回数が０回のため、発作変化率を計算できません。<br>薬剤名・服薬期間を変更して再度お試しください。",
    six_months: "6ヶ月",
    status: "ステータス",
    start_date: "通院開始日",
    step_1: "STEP1",
    step_2: "STEP2",
    step_3: "STEP3",
    step_4: "STEP4",
    summary: "サマリー",
    symptom_example: "症状例",
    symptom_name: "症状名",
    tap_the_otp_issue_button: "ワンタイムパスワード発行ボタンをタップしてください",
    term: {
        article_1: {
            1: "1.「当社」とは、ノックオンザドア株式会社をいいます。",
            2: "2.「利用者」とは、「nanacara」（利用者向けシステム）（以下「本利用者向けシステム」といいます。）を利用するにあたり、当社が定めるnanacara（ナナカラ）利用者用利用規約を承諾の上、当社に対し、当社所定の手続きで会員登録を行い、固有のID、パスワードを取得した個人をいいます。 ",
            3: {
                describe: "3.「本医療者向けシステム」とは、本規約に基づき、主に医療者が患者の自己管理を支援することを目的として、次に定める機能（以下、「本機能」といいます）を管理するためのシステムを総称していいます。",
                detail: {
                    1: "(1)利用者の本利用者向けシステムの利用状況を利用者の同意に基づき閲覧できる機能",
                    2: "(2)本利用者向けシステムを通じて記録されたデータを利用者の同意に基づき検索、閲覧できる機能",
                }
            },
            4: "4.「利用申込」とは、本医療者向けシステムの申込を行う際に使用する当社の指定するメールによる申込（これには、インターネット経由にて申込を行う場合の当社所定の申込画面からの申込を含みます。）をいいます。",
            5: "5.「導入医療機関」とは、本医療者向けシステムを利用する為に利用申込など必要な登録手続きを行い、当社より利用を許諾され本医療者向けシステムを利用する医療機関等（医師個人の場合を含みます。）をいいます。",
            6: "6.「医療者会員」とは、導入医療機関が本医療者向けシステムを利用するにあたり、メールにて明示した導入医療機関の、本医療者向けシステムのサービス利用責任者 、もしくは本医療者向けサービス利用責任者 から本医療者向けシステムの管理権限を付与された者で、本規約および関連する附属規定を承諾の上、当社に対し、当社所定の手続きで会員登録を行い、固有のID、パスワードを当社より取得した個人をいいます。",
            7: "7.「コンテンツ」とは、デジタルデータで表現された文書、音楽、画像、動画などの情報、またはそれらを組み合わせた情報の集合のことをいいます。",
            8: "8.「本データ」とは、本医療者向けシステムを構成するあらゆるプログラム、コンテンツ、ファイル、データベース及び運用データを含むその他一切のデータをいいます。",
            9: "9.「運用データ」とは、利用者による本利用者向けシステムの利用に伴い本医療者向けシステム上にアップロードされ蓄積される各種コンテンツその他一切のデータをいいます。",
            10: "10.「通知」とは、本規約に関連する当社から導入医療機関に対する全ての意思表示の伝達を意味し、その手段は当社が適当と認める方法により行うものとします。なお、当該通知を郵便またはファクシミリにより行う場合において、相手方の所在不明等相手方の責に帰すべき事由により到達しなかった場合は、その発送日から７日を経過した日に相手方に到達したものとみなし、電子メールまたは本システム管理画面上への表示の方法により行う場合には送信時または表示完了時から通知の効力を生じるものとします。",
            11: "11.「告知」とは、本規約に関連する導入医療機関から当社に対する全ての意思表示の伝達を意味し、その手段は郵便、ファクシミリ、電子メールまたはその他のメッセージングシステムによるものとします。",
            describe: "本規約で使用する用語を以下のとおり定義します。",
            title: "第1条（用語の定義）",
        },
        article_2: {
            1: "1.本規約は、当社が提供する本サービスの利用に関し、適用されます。また、導入医療機関は、当社に利用申込を（インターネット経由での申込の場合は、申込画面からの申込送信）した時点で本規約に同意したものとみなされます。",
            2: "2.本サービスを利用するには、当社所定の会員登録を完了し、会員となっていることが必要です。",
            title: "第2条（本規約の適用）",
        },
        article_3: {
            1: "1.当社は、医療者会員にその内容を通知することにより本規約を変更することがあります。その場合、医療者会員は変更後の規定に従うものとします。",
            2: "2.当社は、本システムに関する個別の規定、ガイドライン、諸手続き方法等（以下「個別規定等」と総称します。）を別途定め医療者会員に通知することがあります。この場合、個別規定等はこの規約の一部を構成し、またはこれに準じるものとします。本規約と個別規定等との間に齟齬が生じた場合、個別規定等がこの本規約に優先して適用されるものとします。なお、個別規定等の変更についても前項と同様に医療者会員は従うものとします。",
            3: "3.前2項の通知については、当社が別途定める場合を除き、本医療者向けシステムのTOP画面に変更の旨を表示した後７日間の経過をもってその効力を生じるものとします。なお、導入機関は、当該期間の経過により、その認識の有無を問わず当該変更に同意したものとみなします。",
            title: "第3条（本規約の変更）",
        },
        article_4: {
            1: "1.利用登録希望者は、当社の定める方法によって利用登録を申請し，当社がこれを承認して利用者に登録した旨通知を発することによって利用登録が完了し、その時点から利用することができます。なお、利用登録が完了した翌月1日を「利用可能日」といいます。",
            2: {
                describe: "2.当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。",
                detail: {
                    1: "(1)利用登録の申請に際して虚偽の事項を届け出た場合",
                    2: "(2)本規約に違反したことがある者からの申請である場合",
                    3: "(3)未成年者，成年被後見人，被保佐人または被補助人のいずれかであり，法定代理人，後見人，保佐人または補助人の同意等を得ていなかった場合",
                    4: "(4)当社が定める入会基準を満たさないと当社が判断した場合",
                    5: "(5)反社会的勢力等（暴力団，暴力団員，右翼団体，反社会的勢力，その他これに準ずる者を意味します。）である，または資金提供その他を通じて反社会的勢力等の維持，運営もしくは経営に協力もしくは関与する等反社会的勢力との何らかの交流もしくは関与を行っていると当社が判断した場合",
                    6: "(6)本規約に違反するおそれがあると当社が判断した場合、又は違反した場合",
                    7: "(7)その他，当社が利用登録を相当でないと判断した場合",
                }
            },
            3: "3.医療者会員が登録したメールアドレス宛に、当社ら、本サービスに関する、新機能、更新情報その他本サービスの利用に必要又は有益な情報に関する案内のメールを送付することがあり、医療者会員はこれに同意するものとします。",
            title: "第4条（利用登録）",
        },
        article_5: {
            1: "1.導入医療機関による本医療者用システムの利用期間は、第 4条第 1項のとおり、原則として利用可能日から 1年間とします。 導入医療機関による本医療者用システムの利用期間は、前項の利用期間満了の2ヶ月前までに導入医療機関から別段の意思表示がないときは、期間満了日の翌日からさらに１年間自動的に更新されるものとし、以後も同様とします。",
            2: "2.導入医療機関による都合により、第1項または利用申込に定める契約期間内に解約する場合は、当該契約期間 の末日を持って本医療用システムの利用が停止されます。",
            title: "第5条（利用期間）",
        },
        article_6: {
            1: "1.当社が、諸般の事情により本医療者向けシステムの終了を決定した場合、速やかにその終了予定日（以下、「終了予定日」といいます。）を定め、本システムを終了する旨及び終了予定日を導入医療機関に対して通知するものとします。",
            2: "2.前項の通知は、終了予定日の1ヶ月前までに行うものとします。",
            title: "第6条（本医療者向けシステムの終了）",
        },
        article_7: {
            1: "1.当社は、本医療者向けシステムの導入希望者より利用申込を受け付け、当社が必要な審査や手続等を経た後に利用を承認します。当社と導入医療機関との間における本医療者向けシステムの利用契約の効力の発生（以下、「効力発生」といいます）は、当社が導入医療機関の利用を承認した上で、本医療者向けシステムの利用開始通知を導入医療機関に対して発行した時とします。",
            2: "2.当社は、効力発生以降、導入医療機関に対し、当社が別途指定した任意の日から本医療者向けシステムを提供いたします。",
            title: "第7条（利用の承認）",
        },
        article_8: {
            1: "1.当社は、本医療者向けシステムの導入希望者からの利用申込を独自の基準で審査等をした結果、利用申込を承認しないことがあります。",
            2: "2.利用申込を承認しない場合の理由などは非公開とします。",
            title: "第8条（利用の不承認）",
        },
        article_9: {
            describe: "導入医療機関は、本規約上導入医療機関として有する権利を、第三者に対して譲渡等（名義変更、貸与、質権の設定その他の担保提供等を含みますが、これらに限らないものとします。）を行うことはできないものとします。また、導入医療機関は、当社が導入医療機関に通知することにより、本医療者向けシステム提供者としての契約上の地位並びに本医療者向けシステム提供者の地位に基づく権利及び義務を、全部であるか一部であるかを問わず、第三者へ譲渡、引受け、担保設定、その他如何なる態様による処分を実施できることを承諾します。",
            title: "第9条（譲渡等の禁止）",
        },
        article_10: {
            describe: "導入医療機関は、本規約上導入医療機関として有する権利を、第三者に対して譲渡等（名義変更、貸与、質権の設定その他の担保提供等を含みますが、これらに限らないものとします。）を行うことはできないものとします。また、導入医療機関は、当社が導入医療機関に通知することにより、本医療者向けシステム提供者としての契約上の地位並びに本医療者向けシステム提供者の地位に基づく権利及び義務を、全部であるか一部であるかを問わず、第三者へ譲渡、引受け、担保設定、その他如何なる態様による処分を実施できることを承諾します。",
            title: "第10条（変更の届出）",
        },
        article_11: {
            1: "1.導入医療機関は、自己による本医療者向けシステムの利用と本医療者向けシステムを利用してなされた一切の行為（医療者会員による本システムの利用並びに導入医療機関による利用とみなされる第三者の利用や行為を含みます。以下同様とします。）とその結果について一切の責任を負うものとします。",
            2: "2.導入医療機関は、本医療者向けシステムの利用により当社、医療者会員、利用者その他第三者に対して損害を与えた場合（導入医療機関が、本規約上の義務を履行しないことにより当社、医療者会員、利用者その他第三者が損害を被った場合を含みます。）、自己の責任と費用をもって損害を賠償するものとします。",
            3: {
                describe: "3.導入医療機関は、以下の事項を了承の上、本医療者向けシステムを利用するものとします。",
                detail: {
                    1: "(1)第19条各号及び第20条各号に掲げる場合を含め、本医療者向けシステムに当社に起因しない不具合が生じる場合があること。",
                    2: "(2)当社に起因しない本医療者向けシステムの不具合については、当社は一切その責を免れること。",
                }
            },
            title: "第11条（自己責任の原則）",
        },
        article_12: {
            1: "1.導入医療機関は、自己の責任において、当社が定める条件にて本医療者向けシステムの提供を受けるための設備を設定し、本医療者向けシステム利用のための環境を維持するものとします。",
            2: "2.導入医療機関は、本医療者向けシステムを利用するにあたり、自己の責任をもって、電気通信事業者等が提供する電気通信サービスを利用して前項の設備をインターネットに接続するものとします。",
            3: "3.第１項に定める設備、または前項に定めるインターネット接続及び本医療者向けシステム利用のための環境に不具合がある場合、当社は、導入医療機関に対して本医療者向けシステムの提供の義務を負わないものとします。",
            4: "4.当社は、本医療者向けシステムに関して保守、運用および技術上必要な場合に加え、提供サービスの改善等運営上必要であると判断した場合も医療者会員、利用者が本医療者向けシステムにおいて提供、伝送する運用データ、ログ情報等について、監視、分析、調査等必要な行為を行うことがあり、集積したデータを統計的資料として利用することがあります。",
            title: "第12条（本医療者向けシステム利用のための設備設定・維持）",
        },
        article_13: {
            describe: "導入医療機関は、本医療者向けシステムを利用するにあたり以下の行為を行わず、また医療者会員に行わせてはならないものとします。",
            detail: {
                1: "(1)法令、本規約及び公序良俗に反する行為または違反する虞のある行為。",
                2: "(2)導入医療機関以外を名乗ったり、代表権や代理権がないにもかかわらず、あると偽ったりする行為またはそのおそれがある行為。なお、故意過失に基づいて誤認した場合も含むものとします。",
                3: "(3)本医療者向けシステムを通じて配信されたコンテンツの発信元を隠す、または偽装する行為またはそのおそれがある行為。",
                4: "(4)当社または第三者の所有権、著作権を含む一切の知的財産権、肖像権、パブリシティー権等の正当な権利を侵害する行為。",
                5: "(5)本医療者向けシステムが用いるネットワークシステムを利用して、他のネットワークシステムに不正にアクセスする行為及びそのおそれがある行為、またはこれらのシステムに損害を与える行為及び損害を与えるおそれのある行為。",
                6: "(6)コンピュータのソフトウェア、ハードウェア、通信機器の機能を妨害、破壊、制限するようにデザインされたコンピュータウイルス、コンピュータコード、ファイル、プログラムを含むコンテンツを登録する行為またはそのおそれがある行為。",
                7: "(7)本医療者向けシステムまたは本医療者向けシステムに接続しているサーバ若しくはネットワークを妨害したり、混乱させたりする行為またはそのおそれがある行為。",
                8: "(8)本医療者向けシステムに関するドキュメントやプログラムの改変、解析及び複製等、当社の著作権又は産業財産権を侵害する行為及び派生サービスの作成を行う行為。",
                9: "(9)本医療者向けシステムを不正の目的をもって利用する行為。",
                10: "(10)法令、導入医療機関に適用されるべきルールや規則を遵守せずに本医療者向けシステムを利用する行為。",
                11: "(11)当社からの説明、指示に違反する行為。",
                12: "(12)利用者へ当社所定の患者向け利用規約の説明を行わず、患者側の理解を得ずに本サービスを使用したり、誤解をさせる行為。",
            },
            title: "第13条（遵守事項）",
        },
        article_14: {
            1: "1.導入医療機関は、本医療者システムに関するＩＤ及びパスワードを第三者に開示、貸与、共有しないとともに、第三者に漏洩することのないよう厳重に管理（パスワードの適宜変更を含みます。）するものとします。ＩＤ及びパスワードの管理不備、使用上の過誤、第三者の使用等により導入医療機関、医療者会員、利用者、その他第三者が損害を被った場合、当社は、一切の責任を負わないものとします。",
            2: "2.導入医療機関は、サービス利用責任者に変更が生じた場合、当社に対し速やかに告知するものとします。",
           title: "第14条（サービス利用責任者）",
        },
        article_15: {
            describe: "前条のサービス利用責任者は、本医療者向けシステムに関する当社からの通知についてその内容を逐次確認する義務を負うものとします。当該確認を怠ったことにより発生する導入医療機関、利用者その他第三者の損害について、当社は、一切責任を負わないものとします。",
            title: "第15条（通知確認の義務）",
        },
        article_16: {
            1: "1.導入医療機関は、本医療者向けシステムを複数人の医療者会員で利用する場合、本医療者向けシステムの利用に関するサービス利用責任者を予め定めた上、メールにて当社に告知するものとし、本医療者向けシステムの利用に関する当社との連絡・確認等は、原則としてサービス利用責任者を通じて行うものとします。",
            2: "2.第三者が、導入医療機関のＩＤ及びパスワードを用いて本医療者向けシステムを利用した場合、当該行為は導入医療機関の行為とみなされるものとします。導入医療機関は、当該行為により当社が損害を被った場合、導入医療機関は、当該損害を補填するものとします。",
           title: "第16条（ID及びパスワード）",
        },
        article_17: {
            describe: "導入医療機関は、医療者会員が本医療者向けシステムにおいて提供、伝送する運用データについて、自らの責任でデータ･原資料等をバックアップとして保存しておくものとし、当社は、かかるデータの保管、保存、バックアップ等に関して、導入医療機関に一切の義務を負わないものとします。なお、当社は、万一の障害発生時における復旧に供することを目的に、必要な範囲でバックアップを作成しますが、導入医療機関は、当社に対し当該バックアップについて如何なる請求もなすことはできないものとします。",
            title: "第17条（バックアップ）",
        },
        article_18: {
            1: {
                describe: "1.導入医療機関及び当社は、本システムの履行、その他これに関連して知り得た相手方の技術、営業、業務、財務、組織、その他一切の情報のうち、秘密である旨明示された情報（以下、「秘密情報」といいます。）につき、第三者に開示または漏洩しないものとします。但し、相手方から予め書面による承諾を受けた場合及び次の各号のいずれかに該当する情報についてはこの限りではありません。",
                detail: {
                    1: "(1)秘密保持義務を負うことなく、既に保有している情報",
                    2: "(2)秘密保持義務を負うことなく、第三者から正当に入手した情報",
                    3: "(3)相手方から提供を受けた情報によらず、独自に開発した情報",
                    4: "(4)本規約に違反することなく、かつ、受領の前後を問わず公知となった情報",
                    5: "(5)本条に従った指定、範囲の特定や秘密情報である旨の表示がなされず提供された情報",
                }
            },
            2: "2.前項の定めにかかわらず、導入医療機関及び当社は、秘密情報のうち法令の定めに基づきまたは権限ある官公署からの要求により開示すべき情報を、当該法令の定めに基づく開示先または当該官公署に対し開示することができるものとします。この場合、導入医療機関及び当社は、関連法令に反しない限り、当該開示前に開示する旨を相手方に通知または告知するものとし、開示前に通知または告知を行うことができない場合は開示後速やかにこれを行うものとします。",
            3: "3.秘密情報の提供を受けた当事者は、当該秘密情報の管理に必要な措置を講ずるものとします。",
            4: "4.秘密情報の提供を受けた当事者は、相手方より提供を受けた秘密情報を本システムの遂行目的の範囲内でのみ使用し、必要な範囲内で秘密情報を化体した資料等（以下、本条において「資料等」といいます。）を複製または改変（以下、本項においてあわせて「複製等」といいます。）することができるものとします。この場合、導入医療機関及び当社は、当該複製等された秘密情報についても、本条に定める秘密情報として取り扱うものとします。なお、本システムの遂行に必要な範囲を超える複製等が必要な場合は、予め相手方から書面による承諾を受けるものとします。",
            5: "5.前各項の規定にかかわらず、当社が必要と認めた場合には、第20条第4項所定の委託先に対して、委託のために必要な範囲で、導入医療機関から事前の書面による承諾を受けることなく秘密情報を開示することができます。但し、この場合、当社は、委託先に対して本条に基づき当社が負う秘密保持義務と同等のものを負わせるものとします。",
            6: "6.秘密情報の提供を受けた当事者は、相手方の要請があったときは資料等（本条第4項に基づき相手方の承諾を得て複製、改変した秘密情報を含みます。）を相手方に返還または完全に消去するものとします。",
            7: "7.本条の規定は、本医療者向けシステムの利用期間終了後、期間の定めなく有効に存続するものとします。",
           title: "第18条(秘密保持)",
        },
        article_19: {
            1: {
                describe: "1.当社が本医療者向けシステムの遂行上、提供を受けた個人情報（個人情報の保護に関する法律に定める「個人情報」をいい、以下同様とします。）の主な利用目的は、次のようなものがあります。",
                detail: {
                    1: "(1)導入医療機関または医療者会員への連絡、お問い合わせ対応およびご依頼対応のため",
                    2: "(2)導入医療機関または医療者会員への有益と思われる商品・サービス等の情報提供のため",
                    3: "(3)本医療者向けシステムの広報のため",
                    4: "(4)本医療者向けシステムにおける登録済みの個人情報の属性の集計、分析を行い、個人が識別・特定できないように加工した統計資料を作成し、新規サービスの開発等の業務遂行のため",
                    5: "(5)本医療者向けシステムの機能追加・保守・システム改良・改善のため",
                    6: "(6)学術研究、医療者、患者への教育等のための研究機関との共同研究のため",
                    7: "(7)前各号に規定するほか、前各号に付随する目的のため",
                }
            },
            2: "2.当社は、個人情報について前項に定めるほか、本医療者向けシステムの遂行目的の範囲内でのみ使用し、第三者に開示または漏洩しないものとするとともに、個人情報に関して個人情報の保護に関する法律を含め、関連法令を遵守するものとします。",
            3: "3.当社のプライバシーポリシーについては、本規約に定めるほか以下に記載のとおりです。",
            title: "第19条（個人情報の取り扱い）",
        },
        article_20: {
            1: "1.当社が導入医療機関に提供する本医療者向けシステムの内容は、当社が定めるところによります。",
            2: "2.当社は、本医療者向けシステムの内容・名称を変更することがあります。",
            3: "3.当社は、本医療者向けシステムに付随してまたは本医療者向けシステムもしくは本利用者向けシステムと連動のうえ、他のシステム・サービスを導入医療機関に提供・販売することがあります。提供される商品・サービスの内容、料金等詳細については、別途当社が定めるところによります。",
            4: "4.当社は、本システムの全部若しくはその一部を導入医療機関の事前承諾なしに第三者に委託することができます。",
            5: "5.本医療者向けシステムの実施環境を構成するすべてのプログラム、ハードウェア、ソフトウェア、サービス、手続き、表示等に関する知的財産権その他一切の有体･無体の財産権は当社または当社に対し使用許諾している原権利者に帰属するものとし、導入医療機関は当該権利について、複製、第三者への販売、頒布、第三者への再使用許諾等をすることはできないものとします。",
            6: "6.運用データの知的財産権は、当該データを入力した導入医療機関または医療者会員若しくは利用者に帰属するものとします。なお、導入医療機関は、運用データを当社に対し無償にて、データ保全のためその他本医療者向けシステム遂行上必要な範囲で使用または利用（複製、複写、公衆送信権（送信可能化を含みます。）、翻訳、翻案を含みますが、これらに限りません。）することを予め許諾するとともに、当社の使用または利用が医療者会員および利用者を含む第三者の知的財産権、その他の権利侵害にならないよう予め必要な措置を講ずるものとします。",
            7: "7.運用データは、利用者の承諾に基づき他の導入医療機関または医療者会員に共有されます。また、当社の運営するサービスに関わる分析、並びに個人が識別・特定できないように加工した統計資料の作成、利用および当該統計資料の第三者への提供として利用できるものとします。",
            8: "8.運用データは、利用者からの要望があった場合は、事前の通知なしに導入医療機関または医療者会員への共有を停止できるものとします。",
            9: "9.運用データにより、本医療者向けシステムの保守、運用改善、新機能の追加、当社の新たなシステムの開発等を行うことがあるものとします。",
            title: "第20条（本医療者向けシステムの内容）",
        },
        article_21: {
            1: "1.当社は、本医療者向けシステム提供のために当社が保有・設定し又利用する各種設備（本利用者向けシステムを含むアプリケーションその他のコンピュータソフトウェアのみならずハードウェア、当社と契約しているデータセンター内のサーバ・回線・ネットワーク機器等を含みます。以下、「本システム用設備」といいます。）の保守、工事および障害対応の場合、または天災地変に該当する場合、あるいは電気通信事業者が提供する電気通信の中断・中止等その他やむを得ないときには、本医療者向けシステムの提供の全部若しくはその一部を停止することがあります。",
            2: {
                describe: "2.本医療者向けシステムの提供を停止するときは、当社は、導入医療機関に対し、その旨と本医療者向けシステムの提供停止の期間を事前に通知します。但し、次の各号の事態が生じたときは、事前の通知なしに本システムの提供を停止することができるものとします。",
                detail: {
                    1: "(1)本システム用設備の保守点検を緊急に行う必要があると当社が判断した場合。",
                    2: "(2)火災、停電、天災地変、電気通信事業者が提供する電気通信の中断・中止等当社の責に帰することのできない事由により本医療者向けシステムの提供ができなくなった場合。",
                    3: "(3)戦争、動乱、暴動、騒乱、労働争議等により本医療者システムの提供ができなくなった場合。",
                    4: "(4)その他、運用上、技術上または導入医療機関の利便のため、一時的な本医療者向けシステムの提供停止が必要と当社が判断した場合。",
                    5: "(5)医療者会員が法令または本規約等に違反する利用をした場合。",
                    6: "(6)その他当社が定める正当な理由がある場合。",
                }
            },
            3: "3.当社は、前2項のいずれか、またはその他の事由により本医療者向けシステムの提供の遅延または中断等が発生したとしても、これに起因する導入医療機関、医療者会員その他第三者が被った損害について、本規約で特に定める場合を除き、一切責任を負わないものとします。",
            title: "第21条（本医療者向けシステムの提供の一時停止）",
        },
        article_22: {
            1: {
                describe: "1.当社は、導入医療機関が次の各号のいずれかに該当するときは、催告することなく直ちに本医療者向けシステムの提供の全部若しくはその一部を中止することができるものとします。",
                detail: {
                    1: "(1)本規約に違反した場合。",
                    2: "(2)電話、ＦＡＸ、電子メール、または郵便等による連絡がとれない場合。",
                    3: "(3)利用者から要望があった場合。",
                    4: "(4)その他当社が定める正当な理由がある場合。",
                }
            },
            2: "2.当社は、前項の規定により本医療者向けシステムの提供が中止された場合であっても、これに起因する導入医療機関、医療者会員その他第三者が被った損害について、本規約で特に定める場合を除き、一切責任を負わないものとします。",
            title: "第22条（本医療者向けシステムの提供の中止）",
        },
        article_23: {
            1: "1.導入医療機関は、当社が本規約に基づく義務を履行しない場合、相当の期間を定めたうえで、かかる義務の履行、または違反の是正を催告し、当該期間内にかかる義務の履行または是正がなされないときには、本医療者向けシステムの利用契約の全部若しくはその一部を将来に向かって解除することができるものとします。",
            2: {
                describe: "2.当社は、導入医療機関に以下の各号の一に該当する事由が生じた場合、何らの通知・催告を要せず、直ちに本医療者向けシステムの利用契約を将来に向かって解除することができるものとします。",
                detail: {
                    1: "(1)法令または本規約に違反し、相当の期間を定めたうえで当該違反の是正を催告したにもかかわらず、当該期間内に是正がなされない場合。",
                    2: "(2)重大な背信行為があった場合。",
                    3: "(3)自ら振出しまたは引き受けた手形、小切手につき、不渡り処分を受ける等の支払停止、支払不能の事由が生じた場合。",
                    4: "(4)重要な財産に対する差押、仮差押、仮処分または強制執行若しくは担保権の実行としての競売の申立て、または破産、会社更生手続開始、民事再生手続開始、特別清算開始の申立てを自らなし、または第三者からこれらの申立てがなされた場合。",
                    5: "(5)解散または営業の全部または重要な一部の譲渡を決議した場合。",
                    6: "(6)公租公課の滞納処分を受けた場合。",
                    7: "(7)監督官庁の許認可を必要とされる事業で許認可を取得していなかったことが判明した場合。",
                    8: "(8)監督官庁から営業取消、営業停止等の処分を受けた場合。",
                    9: "(9)資産状態が悪化しまたはそのおそれがあると認めるに足りる相当の理由が生じた場合。",
                    10: "(10)災害、労働争議その他やむを得ない事由により本規約の履行が困難と認めるに足りる相当の事由が生じた場合。",
                    11: "(11)事業内容が公序良俗その他法令に違反する場合、マルチ商法、悪徳商法、ねずみ講など社会的に問題となり得る事業を行っている場合。",
                    12: "(12)本医療者向けシステムと同一または類似の業務を現に行っている場合、または将来行う予定があることが判明した場合。",
                    13: "(13)反社会的活動を行っている場合その他反社会的勢力に該当する場合若しくはこれらと関連があることが判明した場合。",
                    14: "(14)導入医療機関以外を名乗ったり、代表権や代理権がないにもかかわらず、あると偽ったりする行為またはそのおそれがある行為をした場合。",
                    15: "(15)効力発生以降、導入医療機関の実質的支配関係に変動が生じた場合。",
                    16: "(16)その他当社の指示に従わない場合のほか、上記各号の恐れがあると当社が認めた場合。",
                }
            },
            title: "第23条（解除）",
        },
        article_24: {
            describe: "当社は、本医療者向けシステムの実施に関して、本規約に定めるもののほか、以下の各号に掲げる事由から生じた一切の損害（通常損害、逸失利益、間接損害、特別の事情により生じた損害、または第三者から導入医療機関に対しなされた賠償請求に基づく損害を含みますが、これらに限りません。）については、導入医療機関および医療者会員、利用者その他第三者に対し賠償責任を負わないものとします。",
            detail: {
                1: "(1)地震または洪水等の天災地変により、本医療者向けシステムのために当社が設置する本システム用設備が毀損若しくは機能不能、または本データが破損若しくは消失等した場合。",
                2: "(2)当社の責に帰することのできない火災または停電等の災害により、本システム用設備が毀損若しくは機能不能、または本データが破損若しくは消失等した場合。",
                3: "(3)ハッカー等の不正侵入者の行為に起因して、本医療者向けシステム用設備が毀損若しくは機能不能、または本医療者向けデータが破損若しくは消失等した場合。",
                4: "(4)導入医療機関または利用者の誤操作、不適切な登録、設定等に起因して、本システム用設備が毀損若しくは機能不能、または本データが破損若しくは消失等した場合。",
                5: "(5)前四号に掲げる以外の不可抗力、または本システム用設備の自然消耗、その他当社の責に帰することができない事由により、本システム用設備が毀損若しくは機能不能、または本データが破損若しくは消失等した場合。",
                6: "(6)前各号に掲げる事由による本システム用設備の毀損若しくは機能不能に起因して、本データが破損若しくは消失等した場合。",
                7: "(7)当社が、導入医療機関に対し事前に通知したうえで、適宜実施、または導入医療機関の要請に基づき実施する本システム用設備若しくは本医療者向けシステムの更新・メンテナンスのために、本医療者向けシステムが一時的に提供不能となる場合。",
                8: "(8)本医療者向けシステムおよび利用者向けシステムの利用に基づき、医療者会員同士若しくは導入医療機関の医療者会員と利用者その他第三者との間で紛争が生じた場合。",
                9: "(9)第21条で規定する本医療者向けシステムの提供停止の他、導入医療機関または医療者会員または利用者の回線、機器等に起因する通信不良、遅延、誤送、障害等が生じた場合。",
                10: "(10)第三者の提供する機器、サービスまたはソフトウェア起因する通信不良、遅延、誤送、障害等が生じた場合。",
                11: "(11)導入医療機関または利用者が本規約に反するか当社の指示に従わなかったことに起因する一切の事象による場合。",
                12: "(12)回線の混雑等を理由として情報更新遅延に関する損害が発生した場合。",
                13: "(13)本規約及び当社の定める規約、当社の指示に違反したことによって損害が発生した場合。",
            },
            title: "第24条（免責）",
        },
        article_25: {
            1: {
                describe: "1.当社は、導入医療機関が本規約に違反した場合若しくはそのおそれのある場合、導入医療機関による本医療者向けシステムの利用に関し、利用者その他第三者から当社に苦情や請求の申立て等がなされ、かつ当社が適当と認めた場合、またはその他の理由で不適当と当社が判断した場合は、次のいずれかまたはこれらを組み合わせた措置を講ずることがあります。",
                detail: {
                    1: "(1)導入医療機関に対し、本規約に違反する行為またはそのおそれのある行為を止めること、及び同様の行為を繰り返さないことを要求する。",
                    2: "(2)導入医療機関に対し、第三者との間で、苦情や請求等の解消のための協議（裁判外紛争解決手続を含みます。）を行うことを要求する。",
                    3: "(3)導入医療機関に対し、導入医療機関または医療者会員が発信または表示する情報を削除することを要求する。",
                    4: "(4)導入医療機関による本医療者向けシステムの利用の全部または一部を中止する。",
                }
            },
            2: "2.導入医療機関は、前項の規定は当社に同項に定める措置を講ずべき義務を課すものではないことを承諾します。また、導入医療機関は、当社が前項各号に定める措置を講じた場合に、当該措置に起因する結果に関し、当社を免責するものとします。",
            title: "第25条（本規約違反等への対処）",
        },
        article_26: {
            describe: "理由の如何に問わず、本医療者向けシステムの利用期間が終了した場合、導入医療機関は本医療者向けシステムに対するアクセスの権利を失い、当社はいかなる形態であれ本医療者向けシステムを導入医療機関に利用させる義務を負わないものとします。",
            title: "第26条（利用期間終了後の措置）",
        },
        article_27: {
            1: "1.本規約の準拠法は、これを日本国法とします。",
            2: "2.本規約に関して生じた一切の争訟については、東京地方裁判所をもって第一審の専属的合意管轄裁判所とします。",
            title: "第27条（準拠法および合意管轄）",
        },
        article_28: {
            describe: "本規約の各条項の解釈若しくは本規約に定めのない事項について疑義が生じたときは、当社および導入医療機関は信義誠実の原則に従い協議し、速やかにその解決を図るものとします。",
            title: "第28条（協議事項）",
        },
        describe: 'nanacara（ナナカラ）医療関係者向け利用規約（以下「本規約」といいます）は、ノックオンザドア株式会社（以下「当社」といいます）が提供する医療者向けシステム「nanacara for doctor」（以下「本医療者向けシステム」といいます）をご利用になる医療者に対して必要事項を定めるものです。なお、本規約に定めのない事項については、本規約の附属規定である「プライバシーポリシー」に定めるとおりとします。',
        end: "以上",
        title: "利用規約",
    },
    terms_of_service: "利用規約",
    thank_you_for_your_contact: "お問い合わせありがとうございました",
    thank_you_for_your_contact_we_will_check_the_contents: "お問い合わせありがとうございます。<br />内容を確認し担当者より折り返しメールかお電話にてご連絡いたします。<br />",
    the_content_you_entered_is_as_follows: "入力いただいた内容は以下の通りです。誤りがないかご確認ください。<br />特にメールアドレスについては、誤りがありますとお返事ができません。必ずご確認いただきますようお願い申し上げます。",
    the_email_address_is_incorrect_with_status: "メールアドレスが正しくありません。(コード: {status} )",
    the_email_address_or_password_is_incorrect: "メールアドレスまたはパスワードが正しくありません。",
    the_email_address_or_password_is_incorrect_with_status: "メールアドレスまたはパスワードが正しくありません。(コード: {status} )",
    the_format_of_the_email_address_is_different: "メールアドレスの形式が違います。",
    the_left_arm_stretches_the_face_turns_to_the_left_etc: "左うでが伸びる、顔が左に向く、顔の右側がぴくぴくする、両目が右による、口をもぐもぐさせる、急に吐き気がする、など",
    the_medicine_you_are_taking_is_displayed_as_a_bar_at_the_bottom_of_the_graph: "・服薬中の薬剤がグラフ下部にバーで表示されます。",
    the_name_of_the_hospital: "病院名",
    the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended: "ワンタイムパスワードの期限切れたか、ワンタイムパスワードの利用が停止されました。再度ワンタイムパスワード発行を依頼する必要があります(コード: {status} )",
    the_otp_has_not_been_entered_or_the_nanacara_app_has_not_been_set_to_allow_viewing_at_all_times: "ワンタイムパスワードが入力されていないか、nanacaraアプリ側で常時閲覧許可の設定がされていません。<br>ワンタイムパスワードを入力せずに患者情報を閲覧するには、nanacaraアプリ側で<br>の設定が必要です。",
    the_otp_is_incorrect: "ワンタイムパスワードが正しくありません。",
    the_passwords_do_not_match: "パスワードが一致していません。",
    the_patient_information_registered_in_the_nanacara_app_is_displayed: "nanacaraアプリに登録されている患者情報が表示されます。",
    the_presence_or_absence_of_medication_at_the_time_of_seizure_is_marked: "・発作時の頓服薬の有無が●印（複数回投薬した場合は、&#9313;等、回数も表示される）、動画撮影の有無は{img}印で表示されます。",
    the_seizure_graph_can_be_changed_to_a_graph_for_each_seizure_type: "・発作グラフは、発作種類ごとのグラフに表示変更ができます。表示期間は、日間、週間、月間、3ヶ月、6ヶ月、年間の設定が可能です。さらに、週別、月別の設定で、各々、1週間平均の発作回数、1ヶ月平均の発作回数のグラフに表示変更が可能です。",
    the_seizure_type_shortcut_name_is_the_name_displayed_in_the_one_tap_seizure_record_or_seizure_graph: "発作種類のショートカット名は、ワンタップ発作記録や発作グラフに表示される名称です。<br>ご家族の認識しやすい名称を設定してくだい。",
    the_selected_drug: "選択した薬剤",
    the_session_has_expired_please_log_in_again: "セッションの有効期限が切れました。もう一度ログインしてください",
    the_token_has_expired: "トークンの有効期限が切れています",
    the_url_of_the_page_you_are_looking_for_may_have_been_changed_or_deleted: "お探しのページはURLが変更または削除された可能性がございます。",
    the_use_of_otp_was_not_permitted: "ワンタイムパスワードの利用が許可されませんでした",
    the_verification_code_is_different: "確認コードが違います。",
    the_verification_code_is_different_with_status: "確認コードが違います。(コード: {status} )",
    there_is_no_data: "データがありません",
    this_patient_is_allowed_to_view_without_a_otp: "この患者はワンタイムパスワードなしで閲覧を許可しています",
    those_who_have_forgotten_PW: "PWを忘れた方",
    three_months: "3ヶ月",
    time: "回",
    time_times: "0回 | 1回 | {count}回",
    title: "タイトル",
    title_100_characters: "タイトル(100文字)",
    to_select_seizure_classification: "発作分類を選択するには",
    to_use_nanacara_for_doctor_you_need_to_be_able_to_access_the_domain: "nanacara for Doctorのご利用にはapi-dr.kod-hc.jpのドメインにアクセスできる必要があります。",
    today: "今日",
    tonic_clonic_seizures: "強直間代発作",
    tonic_seizures: "強直発作",
    total: "合計",
    total_evaluation_period: "総評価期間",
    under_maintenance: "メンテナンス中",
    unselect_all: "すべて未選択",
    update: "({lastUpdate}更新)",
    updated_note_successfully: "メモが更新されました。",
    upload_attachments: "添付ファイルをアップロード",
    vaccination: '予防接種',
    vaccine_name: "ワクチン名",
    valid: "有効",
    video: "動画",
    view_permission: "閲覧権限",
    waiting_for_otp_aproval: "ワンタイムパス承認待ち",
    waiting_for_user_approval: "ユーザー承認待ち",
    we_are_accepting_questions_from_customers_using_the_contact_form: "お客さまからのご質問をお問い合わせフォームにて受け付けております。<br />必要事項をご記入の上、「入力内容の確認画面へ」を押してください。",
    when_attaching_an_image_file_only_jpeg_png_and_jpg_can_be_uploaded: "画像ファイルを添付する場合は、JPEGとPNGとJPGのみアップロードできます。",
    when_repeating_epileptic_spasm_repeat_like_hiccups_at_intervals_of_about_5_20_seconds: "「てんかん性スパズム」を繰り返す場合(約5-20秒間隔でしゃっくりの様に繰り返す)",
    would_you_like_to_receive_the_notification: "お知らせを配信しますか？",
    year: "年",
    year_month: "{year}年{month}月",
    year_month_day: "{year}年{month}月{day}日",
    year_month_day_hour_minute: "{year}年{month}月{date}日 {hour}:{minute}",
    year_month_day_hour_minute_second: "{year}年{month}月{date}日 {hour}:{minute}:{second}",
    year_month_date_time: "{year}年{month}月{date}日 {times}",
    you_can_view_the_seizure_count_graph_recorded_by_the_patient: "患者が記録した発作回数グラフを閲覧できます。",
    your_name_is_required: "お名前は必須です",
    survey : "ランディングページ",
    verify_code: {
        title: "認証コード入力",
        description: "認証コード入力を送信しました。",
        note: "ご本人様確認のため登録されいている情報に認証コードを送信しました。\n送られている認証コードを入力してください。",
        resend_code_title : "確認コードを送信しました",
        resend_code_content : "こちらの画面を閉じて送られている確認コードを入力してください。",
    }
}